export class Competences {
    public static idDague = 27;
}

export class TypeCompetence {
    id!: number;
}

export class TypeCompetences {
    public values: Map<number, string> = new Map<number, string>([
        [0, "Sans catégorie"],
        [1, "Maniement"],
        [2, "Gredin"],
        [3, "Art"],
        [4, "Talent"]
    ]);
}